<template>
  <hic-dialog title="批量更新" append-to-body @open="open" :close-on-click-modal="false" :visible="visible" width="50rem" @close="cancel" top="4vh">
    <el-form :inline="true" :model="value" ref="editor" label-width="6rem" label-position="right">
      <el-form-item v-if="!value.ifType" label="标准类别" prop="standardClass">
        <hic-dict-selector dict-type="FeeStandardClass" v-model="value.standardClass" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="医保报销" prop="reimburseCategory">
        <hic-dict-selector dict-type="ReimburseCategory" v-model="value.reimburseCategory" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="工伤险报销" prop="injuryReimburseCategory">
        <hic-dict-selector dict-type="ReimburseCategory" v-model="value.injuryReimburseCategory" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="门诊结算" prop="opFeeType">
        <hic-dict-selector dict-type="FeeType" v-model="value.opFeeType" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="住院结算" prop="ipFeeType">
        <hic-dict-selector dict-type="FeeType" v-model="value.ipFeeType" class="edit-input" />
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="统计类别" prop="statisticType">
        <hic-dict-selector dict-type="FeeStatisticType" v-model="value.statisticType" class="edit-input" />
      </el-form-item>
      <el-form-item label="停用" prop="disabled">
        <el-checkbox v-model="value.disabled" class="edit-input" size="small">是</el-checkbox>
      </el-form-item>
      <el-form-item v-if="!value.ifType" label="单位" prop="unit">
        <el-input v-model="value.unit" class="edit-input" size="small" />
      </el-form-item>
      <el-form-item label="备注" prop="memo">
        <el-input type="textarea" placeholder="请输入" v-model.trim="value.memo" :rows="5" style="width: 16rem" size="small"></el-input>
      </el-form-item>
      <el-form-item label="文件依据" prop="paper">
        <el-input type="textarea" placeholder="请输入" v-model.trim="value.paper" :rows="5" style="width: 16rem" size="small"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="cancel">关 闭</el-button>
      <el-button type="primary" @click="save" :disabled="saving">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
  import api from "./api";
  import { mapGetters } from "sw-hic";
  export default {
    props: {
      visible: Boolean,
      value: Object,
      con: Object,
    },
    data() {
      return {
        saving: false,
      };
    },
    computed: {
      ...mapGetters(["dict"]),
    },
    methods: {
      open() {
        if (this.$refs.editor) this.$refs.editor.clearValidate();
      },
      cancel() {
        this.$emit("update:visible", false);
        this.$emit("cancel");
      },
      save() {
        this.$refs.editor.validate().then((valid) => {
          if (valid) {
            this.saving = true;
            api.FeeStandard.batch(this.con, this.value)
              .then((res) => {
                this.$message.success("保存成功!");
                this.$emit("ok");
                this.cancel();
              })
              .catch((err) => {
                this.$message.error(err);
              })
              .finally(() => {
                this.saving = false;
              });
          }
        });
      },
    },
  };
</script>
